/**
 * Mystic Glow — Theme JS
 * Handles: mobile nav toggle, size chip selection, qty stepper, sticky ATC
 */

document.addEventListener('DOMContentLoaded', function () {

  /* ── Mobile nav toggle ─────────────────────────────────────── */
  document.addEventListener('click', function (event) {

    var toggle = event.target.closest('.mobile-toggle');
    if (toggle) {
      var header = toggle.closest('header.site');
      var nav = header && header.querySelector('nav.main-nav');
      if (nav) {
        var open = nav.classList.toggle('mg-mobile-open');
        var navWrapper = header.querySelector('.header-nav-wrapper');
        if (navWrapper) {
          navWrapper.classList.toggle('mg-mobile-open', open);
        }
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.innerHTML = open ? '&#10005;' : '&#9776;'; // ✕ / ☰
      }
      return;
    }

    /* Close mobile nav when clicking outside */
    var openNav = document.querySelector('nav.main-nav.mg-mobile-open');
    if (openNav && !event.target.closest('header.site')) {
      openNav.classList.remove('mg-mobile-open');
      var openWrapper = document.querySelector('.header-nav-wrapper.mg-mobile-open');
      if (openWrapper) openWrapper.classList.remove('mg-mobile-open');
      var btn = document.querySelector('.mobile-toggle');
      if (btn) {
        btn.setAttribute('aria-expanded', 'false');
        btn.innerHTML = '&#9776;';
      }
    }

    /* ── Mobile nav dropdown accordion toggle ──────────────────── */
    var dropdownLink = event.target.closest('.nav-item.has-dropdown > .nav-link');
    if (dropdownLink && window.innerWidth <= 768) {
      event.preventDefault();
      var navItem = dropdownLink.closest('.nav-item.has-dropdown');
      if (navItem) {
        navItem.classList.toggle('is-open');
      }
      return;
    }

    /* ── Size chip selection ───────────────────────────────────── */
    var chip = event.target.closest('.size-chip');
    if (chip) {
      chip.parentElement.querySelectorAll('.size-chip').forEach(function (c) {
        c.classList.remove('selected');
      });
      chip.classList.add('selected');
      return;
    }

    /* ── Qty stepper ───────────────────────────────────────────── */
    var qtyBtn = event.target.closest('[data-qty-step]');
    if (qtyBtn) {
      var input = qtyBtn.closest('.qty-selector').querySelector('input');
      var next  = parseInt(input.value || '1', 10) + parseInt(qtyBtn.getAttribute('data-qty-step'), 10);
      input.value = Math.max(1, next);
    }

  });

  /* ── Sticky mobile ATC ─────────────────────────────────────── */
  var stickyBar = document.querySelector('.sticky-atc');
  if (stickyBar) {
    var threshold = 640;
    window.addEventListener('scroll', function () {
      if (window.scrollY > threshold) {
        stickyBar.classList.add('show');
      } else {
        stickyBar.classList.remove('show');
      }
    }, { passive: true });
  }

  /* ── Gallery thumb switcher (PDP) ─────────────────────────── */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.gallery-thumbs .thumb');
    if (!thumb) return;
    var thumbs = thumb.closest('.gallery-thumbs').querySelectorAll('.thumb');
    thumbs.forEach(function (t) { t.classList.remove('selected'); });
    thumb.classList.add('selected');

    /* Swap main image src if thumb has an img */
    var thumbImg  = thumb.querySelector('img');
    var mainMedia = document.querySelector('.product-main-media');
    if (thumbImg && mainMedia) {
      var mainImg = mainMedia.querySelector('img');
      if (mainImg) {
        mainImg.src = thumbImg.src.replace(/width=\d+/, 'width=1100');
        mainImg.srcset = '';
      }
    }
    /* 🔮 Predictive Search */
  var searchInput = document.querySelector('.header-search-input');
  var searchResults = document.querySelector('.predictive-search-results');
  var searchTimer = null;

  if (searchInput && searchResults) {
    searchInput.addEventListener('input', function() {
      var query = searchInput.value.trim();
      clearTimeout(searchTimer);

      if (!query) {
        searchResults.innerHTML = '';
        return;
      }

      searchTimer = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product')
          .then(function(response) { return response.json(); })
          .then(function(data) {
            var products = data.resources.results.products;
            if (products.length > 0) {
              var html = products.map(function(p) {
                var imageHtml = p.image ? '<img src="' + p.image + '" alt="">' : '';
                return '<a href="' + p.url + '" class="predictive-search-item">' +
                       imageHtml +
                       '<div class="predictive-search-info">' +
                         '<span class="predictive-search-title">' + p.title + '</span>' +
                         '<span class="predictive-search-price">' + p.price + '</span>' +
                       '</div></a>';
              }).join('');
              searchResults.innerHTML = html;
            } else {
              searchResults.innerHTML = '<div class="predictive-search-empty">No results found for "' + query + '"</div>';
            }
          })
          .catch(function() {
            searchResults.innerHTML = '';
          });
      }, 300);
    });

    // Close details when clicking outside
    document.addEventListener('click', function(e) {
      var details = document.querySelector('.header-search-details');
      if (details && details.hasAttribute('open') && !details.contains(e.target)) {
        details.removeAttribute('open');
      }
    });
  }

});

  /* ── FAQ accordion keyboard support ───────────────────────── */
  document.querySelectorAll('.faq-item summary').forEach(function (summary) {
    summary.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        summary.parentElement.toggleAttribute('open');
      }
    });
  });

  /* ============================================================
     MYSTIC GLOW — SIDE-BAR CART DRAWER CONTROLLER
     ============================================================ */
  (function () {
    var drawer = document.getElementById('mg-cart-drawer');
    var overlay = document.getElementById('mg-cart-drawer-overlay');
    if (!drawer) return;

    // Currency Formatter Helper
    function formatMoney(cents) {
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents);
      }
      var rupees = (cents / 100).toFixed(2);
      return '₹' + rupees.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    // Open Cart Drawer
    function openCartDrawer() {
      drawer.classList.add('is-active');
      if (overlay) overlay.classList.add('is-active');
      document.body.classList.add('mg-cart-drawer-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.setAttribute('aria-hidden', 'false');
      refreshCart();
    }

    // Close Cart Drawer
    function closeCartDrawer() {
      drawer.classList.remove('is-active');
      if (overlay) overlay.classList.remove('is-active');
      document.body.classList.remove('mg-cart-drawer-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.setAttribute('aria-hidden', 'true');
    }

    // Expose globally if needed
    window.mgOpenCartDrawer = openCartDrawer;
    window.mgCloseCartDrawer = closeCartDrawer;

    // Header Cart Icon Toggle Event
    document.addEventListener('click', function (e) {
      var cartToggle = e.target.closest('#header-cart-icon') || e.target.closest('[data-cart-drawer-toggle]');
      if (cartToggle) {
        e.preventDefault();
        openCartDrawer();
        return;
      }

      if (e.target.closest('#mg-cart-close-btn') || e.target.closest('#mg-cart-continue-btn') || e.target.closest('#mg-cart-start-shopping')) {
        closeCartDrawer();
        return;
      }
    });

    // Close on Overlay click
    if (overlay) {
      overlay.addEventListener('click', function () {
        closeCartDrawer();
      });
    }

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-active')) {
        closeCartDrawer();
      }
    });

    // Discount Code Accordion Toggle
    var discountToggle = document.getElementById('mg-cart-discount-toggle');
    if (discountToggle) {
      discountToggle.addEventListener('click', function () {
        var expanded = discountToggle.getAttribute('aria-expanded') === 'true';
        discountToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      });
    }

    // Apply Discount Code Handler
    var applyDiscountBtn = document.getElementById('mg-apply-discount-btn');
    var discountInput = document.getElementById('mg-discount-code-input');
    var discountMsg = document.getElementById('mg-discount-message');
    var checkoutDiscountInput = document.getElementById('mg-checkout-discount-input');
    var checkoutForm = document.getElementById('mg-cart-checkout-form');

    if (applyDiscountBtn && discountInput) {
      applyDiscountBtn.addEventListener('click', function () {
        var code = discountInput.value.trim();
        if (!code) {
          if (discountMsg) {
            discountMsg.textContent = 'Please enter a valid discount code.';
            discountMsg.className = 'mg-discount-message error';
          }
          return;
        }

        if (checkoutDiscountInput) {
          checkoutDiscountInput.value = code;
        }

        if (checkoutForm) {
          checkoutForm.action = '/cart?discount=' + encodeURIComponent(code);
        }

        if (discountMsg) {
          discountMsg.textContent = '✓ Discount code "' + code + '" will be applied at checkout.';
          discountMsg.className = 'mg-discount-message success';
        }
      });
    }

    // Update Cart Quantity & Remove
    drawer.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('.mg-qty-btn');
      if (qtyBtn) {
        var key = qtyBtn.getAttribute('data-key');
        var input = drawer.querySelector('.mg-qty-input[data-key="' + key + '"]');
        if (input) {
          var current = parseInt(input.value || '1', 10);
          var action = qtyBtn.getAttribute('data-action');
          var next = action === 'increase' ? current + 1 : current - 1;
          updateCartItem(key, Math.max(0, next));
        }
        return;
      }

      var removeBtn = e.target.closest('.mg-cart-item-remove');
      if (removeBtn) {
        var removeKey = removeBtn.getAttribute('data-remove-key');
        if (removeKey) {
          updateCartItem(removeKey, 0);
        }
        return;
      }
    });

    // Quantity Input Manual Change
    drawer.addEventListener('change', function (e) {
      if (e.target.classList.contains('mg-qty-input')) {
        var key = e.target.getAttribute('data-key');
        var val = parseInt(e.target.value || '0', 10);
        if (key) {
          updateCartItem(key, Math.max(0, val));
        }
      }
    });

    // Order Note Save
    var noteInput = document.getElementById('mg-cart-note-input');
    if (noteInput) {
      var noteTimer = null;
      noteInput.addEventListener('input', function () {
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function () {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: noteInput.value })
          });
        }, 500);
      });
    }

    // Update Cart Item via AJAX
    function updateCartItem(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCartState(cart);
      })
      .catch(function (err) {
        console.error('Error updating cart:', err);
      });
    }

    // Refresh Cart Data
    function refreshCart() {
      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          renderCartState(cart);
        })
        .catch(function (err) {
          console.error('Error fetching cart:', err);
        });
    }

    // Render Cart State to Drawer DOM
    function renderCartState(cart) {
      // 1. Update Header Badges
      var headerCountSpan = document.querySelector('#header-cart-icon .cart-count');
      if (headerCountSpan) headerCountSpan.textContent = cart.item_count;

      var drawerCountSpan = document.getElementById('mg-cart-header-count');
      if (drawerCountSpan) drawerCountSpan.textContent = cart.item_count;

      // 2. Subtotals
      var formattedSubtotal = formatMoney(cart.total_price);
      var subtotalDisplay = document.getElementById('mg-cart-subtotal-display');
      if (subtotalDisplay) subtotalDisplay.textContent = formattedSubtotal;

      var btnSubtotal = document.getElementById('mg-cart-btn-subtotal');
      if (btnSubtotal) btnSubtotal.textContent = formattedSubtotal;

      // 3. Free Shipping Progress Bar
      var shippingBar = document.getElementById('mg-cart-shipping-bar');
      if (shippingBar) {
        var threshold = parseInt(shippingBar.getAttribute('data-threshold') || '199900', 10);
        var remaining = threshold - cart.total_price;
        var textElem = document.getElementById('mg-shipping-text');
        var fillElem = document.getElementById('mg-shipping-progress-fill');

        if (remaining > 0) {
          if (textElem) textElem.innerHTML = 'Add <strong>' + formatMoney(remaining) + '</strong> more to unlock <strong>FREE Shipping</strong>!';
          var pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
          if (fillElem) fillElem.style.width = pct + '%';
        } else {
          if (textElem) textElem.innerHTML = '🎉 You\'ve unlocked <strong>FREE Shipping</strong>!';
          if (fillElem) fillElem.style.width = '100%';
        }
      }

      // 4. Footer visibility & empty state
      var footer = document.getElementById('mg-cart-footer');
      var container = document.getElementById('mg-cart-items-container');

      if (!container) return;

      if (cart.item_count === 0) {
        if (footer) footer.classList.add('is-hidden');
        container.innerHTML = 
          '<div class="mg-cart-empty-state">' +
            '<div class="mg-cart-empty-icon">' +
              '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' +
            '</div>' +
            '<p class="mg-cart-empty-title">Your cart is currently empty</p>' +
            '<p class="mg-cart-empty-desc">Discover our luxurious fragrance collections and add your favorites.</p>' +
            '<button type="button" class="btn btn-solid mg-cart-start-shopping" id="mg-cart-start-shopping">Explore Collection</button>' +
          '</div>';
      } else {
        if (footer) footer.classList.remove('is-hidden');
        var html = cart.items.map(function (item, index) {
          var imageHtml = item.image 
            ? '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy" width="90" height="90">'
            : '<div class="mg-cart-item-placeholder"></div>';

          var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
            ? '<div class="mg-cart-item-variant">' + item.variant_title + '</div>'
            : '';

          var originalPriceHtml = (item.original_line_price > item.final_line_price)
            ? '<span class="mg-cart-item-original-price">' + formatMoney(item.original_line_price) + '</span>'
            : '';

          return '<div class="mg-cart-item" data-line-key="' + item.key + '" data-line-index="' + (index + 1) + '">' +
            '<div class="mg-cart-item-image">' + imageHtml + '</div>' +
            '<div class="mg-cart-item-details">' +
              '<div class="mg-cart-item-header">' +
                '<a href="' + item.url + '" class="mg-cart-item-title">' + item.product_title + '</a>' +
                '<button type="button" class="mg-cart-item-remove" data-remove-key="' + item.key + '" aria-label="Remove item">' +
                  '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>' +
                '</button>' +
              '</div>' +
              variantHtml +
              '<div class="mg-cart-item-price-qty">' +
                '<div class="mg-cart-qty-selector">' +
                  '<button type="button" class="mg-qty-btn mg-qty-minus" data-key="' + item.key + '" data-action="decrease" aria-label="Decrease quantity">−</button>' +
                  '<input type="number" class="mg-qty-input" value="' + item.quantity + '" min="0" data-key="' + item.key + '" aria-label="Quantity">' +
                  '<button type="button" class="mg-qty-btn mg-qty-plus" data-key="' + item.key + '" data-action="increase" aria-label="Increase quantity">+</button>' +
                '</div>' +
                '<div class="mg-cart-item-price">' +
                  originalPriceHtml +
                  '<span class="mg-cart-item-final-price">' + formatMoney(item.final_line_price) + '</span>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</div>';
        }).join('');

        container.innerHTML = html;
      }
    }

    // Intercept Add-to-Cart Forms across the site
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]') || e.target.closest('#pdp-add-to-cart-form') || e.target.closest('.sticky-atc-form') || e.target.closest('.product-card-form');
      if (!form) return;

      e.preventDefault();

      var submitBtn = form.querySelector('[type="submit"]') || form.querySelector('button');
      var originalBtnText = submitBtn ? submitBtn.innerHTML : '';

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = 'Adding...';
      }

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Network response was not ok');
        return res.json();
      })
      .then(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = 'Added! ✓';
          setTimeout(function () {
            submitBtn.innerHTML = originalBtnText;
          }, 1500);
        }
        openCartDrawer();
      })
      .catch(function (err) {
        console.error('Error adding to cart:', err);
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalBtnText;
        }
        // Fallback: standard submission if AJAX fails
        form.submit();
      });
    });

  })();

});

